import { createGuestAnswers, fetchRSVPDetails, findGuest, setGuestInformation } from './asyncThunks';

export const findGuestBuilder = builder => {
  builder.addCase(findGuest.pending, state => {
    state.findGuestPending = true;
  });
  builder.addCase(findGuest.fulfilled, (state, { payload }) => {
    const { data } = payload.data;
    state.findGuestPending = false;
    state.invitationGuestMembers.data = data;
    state.guestAnswers = data.map(guest => {
      return { id: guest.id };
    });
    state.guestFlow.numOfGuest = data.length;
  });

  builder.addCase(findGuest.rejected, (state, action) => {
    state.findGuestPending = false;
  });
};

export const fetchRSVPDetailsBuilder = builder => {
  builder.addCase(fetchRSVPDetails.pending, state => {
    state.fetchRSVPDetailsPending = true;
  });
  builder.addCase(fetchRSVPDetails.fulfilled, (state, { payload }) => {
    const { rsvp, questions } = payload.data;
    state.key = rsvp.rsvpKey;
    state.id = rsvp.id;
    state.brideName = rsvp.brideName;
    state.groomName = rsvp.groomName;
    state.venueName = rsvp.venueName;
    state.venueAddress = rsvp.venueAddress;
    state.dateOfWedding = rsvp.dateOfWedding;
    state.rehearsalDinner = rsvp.rehearsalDinner;
    state.rehearsalVenueName = rsvp.rehearsalVenueName;
    state.dateOfRehearsalDinner = rsvp.dateOfRehearsalDinner;
    state.rehearsalVenueAddress = rsvp.rehearsalVenueAddress;
    state.questions = questions;
    state.fetchRSVPDetailsPending = false;
  });
  builder.addCase(fetchRSVPDetails.rejected, (state, action) => {
    state.fetchRSVPDetailsPending = false;
  });
};

export const createGuestAnswersBuilder = builder => {
  builder.addCase(createGuestAnswers.pending, state => {
    state.createGuestAnswersPending = true;
  });
  builder.addCase(createGuestAnswers.fulfilled, (state, { payload }) => {
    state.createGuestAnswersPending = false;
  });
  builder.addCase(createGuestAnswers.rejected, (state, action) => {
    state.createGuestAnswersPending = false;
  });
};
